import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ONBOARDING_SLICE_NAME, OnboardingState } from './onboarding.types';

export const initialState: OnboardingState = {
  gyms: {
    filters: {
      searchText: null,
    },
  },
};

export const onboardingSlice = createSlice({
  name: ONBOARDING_SLICE_NAME,
  initialState,
  reducers: {
    updateOnboardingGymSearchText(state, action: PayloadAction<string>) {
      state.gyms.filters.searchText = action.payload;
    },
  },
});

export const reducer = onboardingSlice.reducer;
export const Actions = onboardingSlice.actions;
